// Public Supabase config. Which PROJECT this points at is decided at BUILD TIME
// by `tools/platform-env.mjs` (ADR-0016, wired 2026-09-06): CF_PAGES_BRANCH
// `main` -> production, everything else -> staging. It was a hardcoded
// production URL here, which is why the staging project had no client and every
// branch preview read and WROTE to production.
//
// The publishable key is browser-safe either way — it ships inside the bundle
// and RLS plus column grants are what enforce access. Server-only secrets never
// appear in this file; check E10 scans the built output for them.
//
// The `typeof` guard is not defensiveness: outside a build that defines these
// (a bare `tsc`, an editor) the identifier does not exist at all, and reading it
// would be a ReferenceError rather than `undefined`.
const TARGET = {
  url: typeof __PLATFORM_SUPABASE_URL__ === 'string' ? __PLATFORM_SUPABASE_URL__ : '',
  key:
    typeof __PLATFORM_SUPABASE_PUBLISHABLE_KEY__ === 'string'
      ? __PLATFORM_SUPABASE_PUBLISHABLE_KEY__
      : '',
  apiBase: typeof __PLATFORM_API_BASE__ === 'string' ? __PLATFORM_API_BASE__ : '',
};

/** 'production' on a `main` build, 'staging' on every other one. */
export const PLATFORM_ENV = typeof __PLATFORM_ENV__ === 'string' ? __PLATFORM_ENV__ : 'unknown';

export const SUPABASE_URL = TARGET.url;
export const SUPABASE_PUBLISHABLE_KEY = TARGET.key;

// Origin serving the staff edge functions (they deploy with the SITE CF Pages
// project, not this SPA's — the reception CHAT_API_BASE pattern). The chat
// host serves /api/* before and after the WP-exit cutover (ADR-0008). Pair
// with STAFF_ALLOWED_ORIGIN = this app's origin on the site project
// (RUNBOOK §18.7).
export const CLOCK_API_BASE = TARGET.apiBase;

// Same host, generic name — admin-only edge functions (grant-access) live
// under the same /api/admin/* base.
export const ADMIN_API_BASE = CLOCK_API_BASE;
